/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export default function copyMobileApiNavigation() {

	// first check if it is API page
	const apiTree = document.querySelector( '.side-navigation__inner--api' );
	
	if( !apiTree ) {
		return; 
	}

	// check current project
	const currentProject = document.querySelector( 'header.top' ).dataset.project;

	// copy there API tree
	const mobileApiMenu = document.querySelector( `.header__menu-rwd__projects li[ data-project=${ currentProject } ] li[ data-group=api-reference ]` );

	// clone HTML Element with API Tree
	const clonedApiTree = apiTree.firstElementChild.cloneNode( true );

	mobileApiMenu.appendChild( clonedApiTree );
}